const custom_faq_items = document.querySelectorAll(".accordion-inner button");

function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');

  if (itemToggle === 'false') {
    this.setAttribute('aria-expanded', 'true');
  } else {
    this.setAttribute('aria-expanded', 'false');
  }
}

custom_faq_items.forEach(faq_item => faq_item.addEventListener('click', toggleAccordion));
      
